import React, { useMemo, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import api from '../../utils/api';
import { toast } from 'sonner';

export const CategoryManagerDialog = ({ open, onOpenChange, companyId, categories, onCreated }) => {
  const [name, setName] = useState('');
  const [direction, setDirection] = useState('expense');
  const [parentId, setParentId] = useState('none');
  const [vatRate, setVatRate] = useState('');
  const [saving, setSaving] = useState(false);
  const parents = useMemo(() => categories.filter((c) => !c.parent_id && (c.direction === direction || c.direction === 'both')), [categories, direction]);

  const save = async () => {
    setSaving(true);
    try {
      const res = await api.post('/accounting-control/categories', {
        company_id: companyId, name, direction, parent_id: parentId === 'none' ? null : parentId,
        default_vat_rate: vatRate === '' ? null : Number(vatRate),
      });
      toast.success('Voce aggiunta al menu'); onCreated(res.data); setName(''); setParentId('none'); setVatRate(''); onOpenChange(false);
    } catch (error) { toast.error(error.response?.data?.detail || 'Impossibile aggiungere la voce'); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="category-manager-dialog">
        <DialogHeader>
          <DialogTitle>Aggiungi voce di riclassificazione</DialogTitle>
          <DialogDescription>La nuova voce resterà disponibile nel menu di questa società.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Tipo</Label><select value={direction} onChange={(e) => { setDirection(e.target.value); setParentId('none'); }} className="h-9 w-full rounded-md border bg-white px-3 text-sm" data-testid="new-category-type-select"><option value="income">Entrata</option><option value="expense">Uscita</option><option value="both">Entrambe</option></select></div>
          <div><Label>Livello</Label><select value={parentId} onChange={(e) => setParentId(e.target.value)} className="h-9 w-full rounded-md border bg-white px-3 text-sm" data-testid="new-category-parent-select"><option value="none">Nuova categoria principale</option>{parents.map((p) => <option key={p.id} value={p.id}>Sottocategoria di: {p.name}</option>)}</select></div>
          <div><Label>Nome voce</Label><Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Es. Energia elettrica" data-testid="new-category-name-input" /></div>
          <div><Label>IVA predefinita (%)</Label><Input type="number" min="0" max="100" step="0.1" value={vatRate} onChange={(e) => setVatRate(e.target.value)} placeholder="Opzionale" data-testid="new-category-vat-input" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="new-category-cancel-btn">Annulla</Button>
          <Button onClick={save} disabled={saving || !name.trim()} data-testid="new-category-save-btn">{saving ? 'Salvataggio…' : 'Aggiungi al menu'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};